import { activateMenu } from './ms-menu.js';

// ANIMATIONS
// /////////////////////////////////////////////////////////////////////
jQuery(document).ready(function ($) {
  gsap.registerPlugin(ScrollTrigger);
  // HOME
  if ($('.wrapper__home').length > 0) {
    function homeScroll() {
      const $section = $('.wrapper__home');
      const $startTrigger = $('.c-header');
      const $scrollBar = $('.section__hero-line');

      const greenToWhite = gsap.fromTo(
        $section,
        { backgroundColor: '#dad9ce' },
        { backgroundColor: 'rgb(255, 255, 255)' }
      );

      ScrollTrigger.create({
        trigger: $startTrigger,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        animation: greenToWhite
      });

      const fade = gsap.to($scrollBar, {
        opacity: 0
      });

      ScrollTrigger.create({
        trigger: $startTrigger,
        start: 'top top',
        end: 'bottom 80%',
        scrub: true,
        animation: fade
      });
    }
    homeScroll();
  }
  // PROJECTS
  if ($('.wrapper__projects').length > 0) {
    function projectsScroll() {
      const $section = $('.wrapper__projects');
      const $startTrigger = $('.c-header');
      const $scrollBar = $('.section__hero-line');

      const greenToWhite = gsap.fromTo(
        $section,
        { backgroundColor: '#dad9ce' },
        { backgroundColor: 'rgb(255, 255, 255)' }
      );

      ScrollTrigger.create({
        trigger: $startTrigger,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        animation: greenToWhite
      });

      const fade = gsap.to($scrollBar, {
        opacity: 0
      });

      ScrollTrigger.create({
        trigger: $startTrigger,
        start: 'top top',
        end: 'bottom 80%',
        scrub: true,
        animation: fade
      });
    }
    projectsScroll();
  }
  // TEAM
  if ($('.wrapper__team').length > 0) {
    function teamScroll() {
      const $section = $('.wrapper__team');
      const $startTrigger = $('.c-header');
      const $scrollBar = $('.section__hero-line');

      const greenToWhite = gsap.fromTo(
        $section,
        { backgroundColor: '#dad9ce' },
        { backgroundColor: '#959982' }
      );

      ScrollTrigger.create({
        trigger: $startTrigger,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        animation: greenToWhite
      });

      const fade = gsap.to($scrollBar, {
        opacity: 0
      });

      ScrollTrigger.create({
        trigger: $startTrigger,
        start: 'top top',
        end: 'bottom 80%',
        scrub: true,
        animation: fade
      });
    }
    teamScroll();
  }
  // APPROACH
  if ($('.wrapper__approach').length > 0) {
    function approachScroll() {
      const $section = $('.wrapper__approach');
      const $startTrigger = $('.c-header');
      const $scrollBar = $('.section__hero-line');

      const greenToWhite = gsap.fromTo(
        $section,
        { backgroundColor: '#dad9ce' },
        { backgroundColor: 'rgb(255, 255, 255)' }
      );

      ScrollTrigger.create({
        trigger: $startTrigger,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        animation: greenToWhite
      });

      const fade = gsap.to($scrollBar, {
        opacity: 0
      });

      ScrollTrigger.create({
        trigger: $startTrigger,
        start: 'top top',
        end: 'bottom 80%',
        scrub: true,
        animation: fade
      });
    }
    approachScroll();
  }
  // BLOG
  if ($('.wrapper__blog').length > 0) {
    function blogScroll() {
      const $section = $('.wrapper__blog');
      const $startTrigger = $('.section__blog--hero');
      const $scrollBar = $('.section__blog-line');

      const greenToWhite = gsap.fromTo(
        $section,
        { backgroundColor: '#dad9ce' },
        { backgroundColor: '#f4ece2' }
      );

      ScrollTrigger.create({
        trigger: $startTrigger,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        animation: greenToWhite
      });

      const fade = gsap.to($scrollBar, {
        opacity: 0
      });

      ScrollTrigger.create({
        trigger: $startTrigger,
        start: 'top top',
        end: 'bottom 80%',
        scrub: true,
        animation: fade
      });
    }
    blogScroll();
  }
});

// FLICKITY
// /////////////////////////////////////////////////////////////////////
function initFlickitySlide() {
  //   Variables
  const slideHome = document.querySelector('.gardens-carousel');

  //   Create Flickity
  let flickity = new Flickity(slideHome, {
    autoPlay: false,
    pageDots: false,
    draggable: true,
    cellAlign: 'left',
    wrapAround: true,
    selectedAttraction: 0.015,
    friction: 0.25,
    cellSelector: '.gardens-carousel__cell'
  });
}

function initFlickityTestimonials() {
  //   Variables
  const testimonialsProjects = document.querySelector('.testimonials__carousel');

  //   Create Flickity
  let flickity = new Flickity(testimonialsProjects, {
    autoPlay: false,
    pageDots: true,
    draggable: true,
    cellAlign: 'center',
    wrapAround: true,
    selectedAttraction: 0.015,
    friction: 0.25,
    cellSelector: '.testimonials__cell'
  });
}

let home = '/';
let projects = '/projects/';

jQuery(document).ready(function ($) {
  if (document.location.pathname === home) {
    initFlickitySlide();
    console.log('success');
  }
  if (document.location.pathname === projects) {
    initFlickityTestimonials();
    console.log('success');
  }
});
